namespace GeniuzPOS.Product {
    export interface CsSkuForm {
        SkuCode: Serenity.StringEditor;
        ActiveFg: Serenity.IntegerEditor;
        SkuDesc: Serenity.StringEditor;
        SkuEnDesc: Serenity.StringEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        ProductCpComponent: Serenity.StringEditor;
        ProductCpDesc1: Serenity.StringEditor;
        ProductCpDesc2: Serenity.StringEditor;
        ProductCpHowToUse: Serenity.StringEditor;
        ProductCpWarning: Serenity.StringEditor;
        SupplierId: Serenity.LookupEditor;
        CusImportOrLocal: Serenity.StringEditor;
        MarketDate: Serenity.DateEditor;
        ExpDate: Serenity.DateEditor;
        VatType: Serenity.LookupEditor;
        VatCode: Serenity.LookupEditor;
        ConsignFg: Serenity.BooleanEditor;
        ConsignGp: Serenity.DecimalEditor;
        CusProductTypeNbp: Serenity.StringEditor;
        ActivePurFg: Serenity.BooleanEditor;
        ActiveSellFg: Serenity.BooleanEditor;
        ActiveRepFg: Serenity.BooleanEditor;
        CusProductSalesBeforeFlag: Serenity.StringEditor;
        CusProductSalesBeforeReferFlag: Serenity.StringEditor;
        CusProductSalesBeforeRefer: Serenity.StringEditor;
        ProdImageLink: Serenity.MultipleImageUploadEditor;
        StockFg: Serenity.BooleanEditor;
        SetItemFg: Serenity.BooleanEditor;
        NonAllowtoDiscountFg: Serenity.BooleanEditor;
        PurLeadTime: Serenity.DecimalEditor;
        StkUnit: Serenity.LookupEditor;
        MinStockQty: Serenity.DecimalEditor;
        MaxStockQty: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        PurUnit: Serenity.LookupEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        LastPurPrice: Serenity.DecimalEditor;
        QtyOnhand: Serenity.DecimalEditor;
        StockCostValue: Serenity.DecimalEditor;
    }

    export class CsSkuForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsSku';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsSkuForm.init)  {
                CsSkuForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DateEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.MultipleImageUploadEditor;

                Q.initFormType(CsSkuForm, [
                    'SkuCode', w0,
                    'ActiveFg', w1,
                    'SkuDesc', w0,
                    'SkuEnDesc', w0,
                    'BrandCode', w2,
                    'CatCode', w2,
                    'SubCat1Code', w2,
                    'SubCat2Code', w2,
                    'StyleId', w2,
                    'ColorId', w2,
                    'SizeId', w2,
                    'TasteId', w2,
                    'MatTypeId', w2,
                    'ProductCpComponent', w0,
                    'ProductCpDesc1', w0,
                    'ProductCpDesc2', w0,
                    'ProductCpHowToUse', w0,
                    'ProductCpWarning', w0,
                    'SupplierId', w2,
                    'CusImportOrLocal', w0,
                    'MarketDate', w3,
                    'ExpDate', w3,
                    'VatType', w2,
                    'VatCode', w2,
                    'ConsignFg', w4,
                    'ConsignGp', w5,
                    'CusProductTypeNbp', w0,
                    'ActivePurFg', w4,
                    'ActiveSellFg', w4,
                    'ActiveRepFg', w4,
                    'CusProductSalesBeforeFlag', w0,
                    'CusProductSalesBeforeReferFlag', w0,
                    'CusProductSalesBeforeRefer', w0,
                    'ProdImageLink', w6,
                    'StockFg', w4,
                    'SetItemFg', w4,
                    'NonAllowtoDiscountFg', w4,
                    'PurLeadTime', w5,
                    'StkUnit', w2,
                    'MinStockQty', w5,
                    'MaxStockQty', w5,
                    'PurUnitRatio', w5,
                    'PurUnit', w2,
                    'PurUnitPrice', w5,
                    'LastPurPrice', w5,
                    'QtyOnhand', w5,
                    'StockCostValue', w5
                ]);
            }
        }
    }
}
